import {memo} from "react";
import {Table} from "antd";
import className from "classnames/bind";
import {
	Image,
	PopperUserInfo
} from "~/components";
import style from "./CallSource.module.scss";

const cn = className.bind(style);

function percent(part, total) {
	if(!total) return '0%';
	return Math.round((part / total) * 100) + '%';
}

function CallSourceReportTable({groups = []}) {

	const columns = [
		{ title: 'Nhân viên', dataIndex: 'user', key: 'user', render: (_, item) => (
			<PopperUserInfo user={item.user}>
				<div className="d-flex gap align-items">
					<div className="avatar"><Image src={item?.user?.avatar} /></div>
					<div>
						<b>{`${item?.user?.firstname || ''} ${item?.user?.lastname || ''}`}</b>
						<p>{item?.user?.username}</p>
					</div>
				</div>
			</PopperUserInfo>
		)},
		{ title: 'Nguồn tìm được', dataIndex: 'sources', key: 'sources', width: '120px', align: 'center', render: (_, item) => (
			<b className="text-md">{item.sources}</b>
		)},
		{ title: 'Đã gọi', dataIndex: 'called', key: 'called', width: '110px', align: 'center', render: (_, item) => (
			<>{item.called} <span className="color-gray">({percent(item.called, item.sources)})</span></>
		)},
		{ title: 'Chưa gọi', dataIndex: 'uncalled', key: 'uncalled', width: '90px', align: 'center', render: (_, item) => (
			<>{item.uncalled}</>
		)},
		{ title: 'Đã hẹn', dataIndex: 'appointment', key: 'appointment', width: '110px', align: 'center', render: (_, item) => (
			<b className="color-green">{item.appointment} <span className="color-gray">({percent(item.appointment, item.sources)})</span></b>
		)},
		{ title: 'Cuộc gọi trong kỳ', dataIndex: 'calls', key: 'calls', width: '130px', align: 'center', fixed: 'right', render: (_, item) => (
			<b className="text-md">{item.calls}</b>
		)},
	];

	return (
		<div className="table-wrapper">
			{groups.map((group) => (
				<div className={cn('groupBlock')} key={`call-source-group-${group.id}`}>
					<div className={cn('groupHeader')}>
						<h3 className={cn('groupName')}>{group.name || 'Chưa phân nhóm'}</h3>
						<div className={cn('groupMeta')}>
							<span className={cn('pill')}><b>{group.sources}</b> nguồn</span>
							<span className={cn('pill')}><b>{group.calls}</b> cuộc gọi</span>
							<span className={cn('pill', 'pillGreen')}><b>{group.appointment}</b> đã hẹn</span>
						</div>
					</div>
					<div className="table-box">
						<Table
							columns={columns}
							rowKey={(row) => row.user?.id}
							dataSource={group.users}
							scroll={{ x: 'max-content' }}
							pagination={false}
							summary={() => (
								<Table.Summary fixed>
									<Table.Summary.Row>
										<Table.Summary.Cell index={0}><b>Tổng nhóm</b></Table.Summary.Cell>
										<Table.Summary.Cell index={1} align="center"><b>{group.sources}</b></Table.Summary.Cell>
										<Table.Summary.Cell index={2} align="center"><b>{group.called}</b></Table.Summary.Cell>
										<Table.Summary.Cell index={3} align="center"><b>{group.uncalled}</b></Table.Summary.Cell>
										<Table.Summary.Cell index={4} align="center"><b>{group.appointment}</b></Table.Summary.Cell>
										<Table.Summary.Cell index={5} align="center"><b>{group.calls}</b></Table.Summary.Cell>
									</Table.Summary.Row>
								</Table.Summary>
							)}
						/>
					</div>
				</div>
			))}
		</div>
	)
}

export default memo(CallSourceReportTable);
